
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.453 13.412v-2.251h2.389c.299-2.928 1.114-5.081 2.445-6.459s3.466-2.067 6.403-2.067c2.091 0 4.356.258 6.795.775l-.112 2.288c-2.265-.418-4.418-.627-6.459-.627s-3.528.48-4.461 1.439c-.933.96-1.512 2.51-1.736 4.651h10.677v2.251H11.567a32.455 32.455 0 00-.037 1.845v1.661h10.864v2.251H11.679c.224 2.141.803 3.697 1.736 4.669s2.433 1.458 4.499 1.458 4.219-.221 6.459-.664l.112 2.325c-2.464.517-4.729.775-6.795.775-2.937 0-5.071-.701-6.403-2.104s-2.159-3.556-2.483-6.459H6.452v-2.251h2.24c-.025-.345-.037-.917-.037-1.716s.012-1.396.037-1.79h-2.24z"}})])
          )
        }
      }
    